export function getValueByPath(object, path) {
  return path.split(".").reduce((acc, part) => {
    return acc && acc[part];
  }, object);
}
export function setValueByPath(object, path, value, initialize = true) {
  const parts = path.split(".");
  const key = parts.pop();
  let target = object;
  parts.forEach((part) => {
    if (!target.hasOwnProperty(part) && initialize) {
      target[part] = {};
    }
    target = target[part];
  });
  if (target && key) {
    target[key] = value;
  }
  return object;
}
export function setValuesAlongPath(object, path, values) {
  if (path) {
    path.split(".").reduce((acc, part) => {
      Object.keys(values).forEach((key) => {
        acc[part][key] = values[key];
      });
      return acc && acc[part];
    }, object);
  }
  Object.keys(values).forEach((key) => {
    object[key] = values[key];
  });
  return object;
}
